import React, { useContext, useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';
import { Space, Table, Tag, Button } from 'antd';

import { numberFormatter } from '../../../components/formatters/numberFormatter';




const LoadExpenseJv = (props) => {

    const { setTransactions, journalVoucher, selectedCurrency, vatAmount, totalPrice, netPrice, cart } = props;

    const { api, userData, settingData, auxAccountData, secondaryCurrency, rateMainToSecondaryCurrency, rateToMainCurrency } = useContext(DataContext);
    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role;



    // load Transactions
    useEffect(() => {
        loadJV();
    }, [journalVoucher, vatAmount, totalPrice, netPrice, cart]);

    const accountId = journalVoucher?.accountId;
    const secondaryAccountId = journalVoucher?.secondaryAccountId;
    const accountType = auxAccountData?.find(account => account.id === secondaryAccountId)?.type;

    const vatExpenseAccountId = settingData.vatExpenseAccountId;
    const vatAssetAccountId = settingData.vatAssetAccountId;

    const warehouseId = journalVoucher?.warehouseId;
    const cashAccountId = journalVoucher.cashAccountId;
    const isDebit = journalVoucher.isDebit;



    const total = journalVoucher.totalCredit;

    const rate = selectedCurrency?.rate;
    const currencyId = selectedCurrency?.id;


    const loadJV = () => {

        let updatedTransactions = [];

        // expense
        updatedTransactions = loadAcountTransaction(updatedTransactions, true, secondaryAccountId, 'Expense', netPrice, true);


        // supplier
        if (accountId) {
            updatedTransactions = loadAcountTransaction(updatedTransactions, false, accountId, 'Supplier', totalPrice, false);
        }

        // vat
        if (vatAmount > 0) {
            let vatAccountId;
            if (accountType == 'Expenses') {
                vatAccountId = vatExpenseAccountId;
            } else if (accountType == 'Assets') {
                vatAccountId = vatAssetAccountId;
            }
            updatedTransactions = loadAcountTransaction(updatedTransactions, true, vatAccountId, 'VAT', vatAmount, false);
        }

        // cash
        if (journalVoucher.paymentType == 'cash') {
            if (journalVoucher.accountId) {
                updatedTransactions = loadAcountTransaction(updatedTransactions, true, accountId, 'Supplier', totalPrice, false);
            }
            updatedTransactions = loadAcountTransaction(updatedTransactions, false, cashAccountId, 'Cash', totalPrice, false);
        }

        setTransactions(updatedTransactions)

    }



    const loadAcountTransaction = (updatedTransactions, isDebit, accountId, type, total, haveCart) => {


        const debit = isDebit ? total : 0;
        const credit = !isDebit ? total : 0;

        const totalDebit = rateToMainCurrency(selectedCurrency, debit);
        const totalCredit = rateToMainCurrency(selectedCurrency, credit);

        const secondaryTotalDebit = rateMainToSecondaryCurrency(totalDebit);
        const secondaryTotalCredit = rateMainToSecondaryCurrency(totalCredit);

        const accountTransaction = {
            type: type,
            accountId: accountId,
            details: '',
            isDebit: isDebit,
            debit: debit,
            credit: credit,
            totalDebit: totalDebit,
            totalCredit: totalCredit,
            secondaryTotalDebit: secondaryTotalDebit,
            secondaryTotalCredit: secondaryTotalCredit,
            currencyId: currencyId,
            rate: rate,
            haveCart: haveCart,
        }

        updatedTransactions.push(accountTransaction);

        return updatedTransactions;
    }




    return (


        <></>

    )
}


export default LoadExpenseJv;